import { safeHTML } from '../../../../../utils/safeHTML';
import { useTranslation } from '../../../../../translations';
import classNames from 'classnames';
import combineModifiers from '../../../../../utils/modifiers/combineModifiers';

export default function Text({ className, value, modifier, isUseTranslation = true, noMin }) {
  const { t } = useTranslation();

  return (
    value && (
      <div
        className={classNames(
          'universal-modal__text',
          className,
          {
            ['universal-modal__text_min']: isMin(),
          },
          ...combineModifiers('universal-modal__text', modifier),
        )}
      >
        {safeHTML(isUseTranslation ? t(value) : value)}
      </div>
    )
  );

  function isMin() {
    if (noMin) {
      return false;
    } else {
      return isUseTranslation ? t(value).length : value.length > 150;
    }
  }
}
